class CreateLink {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const windowWidth = $(window).width();
    const windowSm = 768;
    if (windowWidth <= windowSm) {
      //横幅768px以下（スマホ）に適用させるJavaScriptを記述
      const linkSp = document.createElement('span');
      const ulSp = document.getElementById('pgc-941-4-0');
      linkSp.innerHTML = '<a href="https://dept.dokkyomed.ac.jp/dep-m/kensyui-boshu/index.php#!page2" target="_blank" class="createLink">' + '</a>'
      ulSp.appendChild(linkSp);
    } else {
      //横幅768px以上（PC、タブレット）に適用させるJavaScriptを記述
      const link = document.createElement('span');
      const ul = document.querySelector('.so-widget-sow-image-default-c67d20f9f743-941');
      link.innerHTML = '<a href="https://dept.dokkyomed.ac.jp/dep-m/kensyui-boshu/index.php#!page2" target="_blank" class="createLink">' + '</a>'
      ul.appendChild(link);
    }
  }
}